module.exports = __webpack_public_path__ + "img/goal-fifteen-en.cac49adc.png";